import { Controller } from "@hotwired/stimulus"

// The document viewer's frame: scrolls the row of paperwork pills
// (paperwork_attachments/_viewer_nav) sideways under a mouse wheel, which only
// moves up and down. A trackpad already scrolls it sideways.
export default class extends Controller {
  scrollSideways(event) {
    if (event.deltaX !== 0 || event.deltaY === 0 || event.shiftKey) return
    const list = event.currentTarget
    if (list.scrollWidth <= list.clientWidth) return
    event.preventDefault()
    list.scrollLeft += event.deltaY
  }
}
